import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import api from "@/lib/axios"

const getListlayananSmartPayment = async () => {
  const response = await api.get("/master/layanan-smartpayment/index")
  return response.data?.data
}

export default function MasterLayananSmartPaymentPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listLayananSmartPayment"],
    queryFn: getListlayananSmartPayment,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
